<template>
  <component :is="component" :class="{invalid}">
    <slot />
  </component>
</template>

<script>
export default {
  props: {
    component: {
      default: "div"
    }
  },
  computed: {
    invalid() {
      return false;
    },
  }
}
</script>
